module.exports = __webpack_public_path__ + "static/finley-book-yellowstone-e6aa7e6692c4aa88a8d13e249e454a67.jpg";